import { formatDate } from "@angular/common";
import { Component, Input, OnInit, Inject } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { AdminService } from "../admin.service";
import { Observable, map, startWith } from "rxjs";

@Component({
  selector: "app-admin-do-truckowner",
  templateUrl: "./admin-do-truckowner.component.html",
  styleUrls: ["./admin-do-truckowner.component.css"],
})
export class AdminDoTruckownerComponent implements OnInit {
  workorderArray: any;
  truckownerArray: any;
  driverControl: FormControl;
  vehicleArray: any;
  token: any;
  doTruckOwnerForm: FormGroup;
  selectedWorkOrderQty: any;
  work_order_msg: any;
  dateFormat = "dd-MM-yyyy";
  language = "en";
  workOrderQnty: any;
  total_quantity: any;
  work_order_qty: any;
  selectedLoadedQuantity: any;
  @Input() min: any;
  minDate = new Date();
  @Input() max: any;
  maxDate = new Date();
  filteredDriver: Observable<any[]>;
  selectdCategId: any;
  quantity: any;
  showRadioButtons: boolean = false;
  isLoadedQuantitySelected: boolean = false;
  isUnloadedQuantitySelected: boolean = false;
  loading: boolean = false;
  constructor(
    private matdialogref: MatDialogRef<AdminDoTruckownerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: AdminService,
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.maxDate.setDate(this.maxDate.getDate() + 2);
  }

  ngOnInit(): void {
    this.token = localStorage.getItem("adminToken");
    this.doTruckOwnerForm = this.formBuilder.group({
      workorder_id: [""],
      act_ton: [""],
      work_date: [""],
      workorder_qty: [""],
      do_issue_date: [""],
      do_quantity: [""],
      price_per_ton: [""],
      sales_order_no: [""],
      pay_as_load_quantity: [""],
      remaining_tons: [""],
      truckowner_id: [""],
      truckowner_number: [""],
      total_tons: [""],
    });
    // this.workOrder();
    // this.truckOwner();
    
    if (this.data) {
      this.workorderArray = [this.data];
      this.doTruckOwnerForm.patchValue({
        workorder_id: this.data._id
      });
      this.selectChangeHandler(this.data);
    }
  }
  close() {
    this.matdialogref.close();
  }

  public formatFormDate(date: Date) {
    return formatDate(date, this.dateFormat, this.language);
  }

  workOrder() {
    this.services.ListWorkOrder(this.token).subscribe(
      (response: any) => {
        this.vehicleArray = response.body.data;
        this.workorderArray = response.body;
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  filterDrivers(value: any) {
    const filterValue = value.toLowerCase();

    return this.truckownerArray.filter((option: any) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  truckOwner() {
    this.services
      .getTruckOwnerDetails(this.token, this.selectdCategId)
      .subscribe(
        (response: any) => {
          this.truckownerArray = response.body.data.filter(
            (item: any) => item.username
          );
          this.filteredDriver = this.driverControl.valueChanges.pipe(
            startWith(""),
            map((state) =>
              state ? this.filterDrivers(state) : this.truckownerArray.slice()
            )
          );
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  selectChangeHandler(item: any) {
    this.selectdCategId = "";
    this.selectdCategId = item.truck_category;
    this.selectedWorkOrderQty = item;
    this.work_order_msg = item.workorder_id;
    let _id = item._id || this.doTruckOwnerForm.value.workorder_id;
    this.services
      .selectedWorkOrder(_id, this.token)
      .subscribe((response: any) => {
        let resData = Array.isArray(response.body.data) ? response.body.data[0] : response.body.data;
        this.quantity = resData;
        this.truckOwner();

        this.doTruckOwnerForm.patchValue({
          act_ton: resData.price_per_ton ? resData.price_per_ton.toFixed(2) : "",
          total_tons: resData.total_tons ? resData.total_tons.toFixed(3) : "",
          remaining_tons: resData.remaining_tons ? resData.remaining_tons.toFixed(3) : "",
          work_date: resData.createdAt ? this.formatFormDate(resData.createdAt) : "",
        });
        this.total_quantity = resData.remaining_tons;
        this.showRadioButtons = true;
        this.updateRadioButtonsVisibility(
          resData.pay_as_load_quantity
        );
      });
  }

  private updateRadioButtonsVisibility(selectedQuantity: string): void {
    this.isLoadedQuantitySelected = selectedQuantity === "loaded_quantity";
    this.isUnloadedQuantitySelected = selectedQuantity === "unloaded_quantity";
  }

  selectChangeHandlerTruck(item: any) {
    this.doTruckOwnerForm.patchValue({
      truckowner_number: item.mobile,
    });
  }

  remainingQnty(event: any) {
    this.workOrderQnty = event.target.value;
    this.work_order_qty = (this.total_quantity - this.workOrderQnty).toFixed(3);
    if (
      this.work_order_qty >= 0 ||
      this.workOrderQnty === this.work_order_qty
    ) {
      this.doTruckOwnerForm.patchValue({
        remaining_tons: (this.total_quantity - this.workOrderQnty).toFixed(3),
      });
    } else {
      this.doTruckOwnerForm.patchValue({
        remaining_tons: this.total_quantity.toFixed(3),
      });
      this.snackBar.open(
        "Do Quantity Should not Exceed With Work Order Quantity",
        "Fail",
        {
          duration: 5000,
        }
      );
    }
  }

  selectLoadedQty(event: any) {
    this.selectedLoadedQuantity = event;
  }

  doTruckowner(event: any) {
    if (!this.doTruckOwnerForm.valid || this.loading) {
      return; // 🚀 Prevent clicks if already loading
    }
    this.loading = true; // ✅ Disable button immediately
    (event.target as HTMLButtonElement).disabled = true; // ✅ Disable button instantly
    let workorder_id = this.doTruckOwnerForm.value.workorder_id;
    if (!workorder_id) {
      this.snackBar.open("Please select Work order number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let do_issue_date = this.doTruckOwnerForm.value.do_issue_date;
    if (!do_issue_date) {
      this.snackBar.open("Please select do issue dater", "Fail", {
        duration: 5000,
      });
      return;
    }
    let truckowner_id = this.doTruckOwnerForm.value.truckowner_id;
    if (!truckowner_id) {
      this.snackBar.open("Please select truck name", "Fail", {
        duration: 5000,
      });
      return;
    }
    let do_quantity = this.doTruckOwnerForm.value.do_quantity;
    if (!do_quantity) {
      this.snackBar.open("Please enter Do quantity", "Fail", {
        duration: 5000,
      });
      return;
    }
    let price_per_ton = this.doTruckOwnerForm.value.price_per_ton;
    if (!price_per_ton) {
      this.snackBar.open("Please enter price per ton", "Fail", {
        duration: 5000,
      });
      return;
    }
    let sales_order_no = this.doTruckOwnerForm.value.sales_order_no;
    if (!sales_order_no) {
      this.snackBar.open("Please enter sales order number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let pay_as_load_quantity = this.doTruckOwnerForm.value.pay_as_load_quantity;
    if (!pay_as_load_quantity) {
      this.snackBar.open("Please select quantity", "Fail", {
        duration: 5000,
      });
      return;
    }

    const truckObj = {
      workorder_id: this.doTruckOwnerForm.value.workorder_id,
      truckowner_id: this.doTruckOwnerForm.value.truckowner_id,
      do_issue_date: this.formatFormDate(
        this.doTruckOwnerForm.value.do_issue_date
      ),
      do_quantity: Number(this.doTruckOwnerForm.value.do_quantity),
      price_per_ton: Number(this.doTruckOwnerForm.value.price_per_ton),
      sales_order_no: this.doTruckOwnerForm.value.sales_order_no,
      pay_as_load_quantity: this.selectedLoadedQuantity,
      remaining_tons: Number(this.doTruckOwnerForm.value.remaining_tons),
    };
    if (
      this.work_order_qty >= 0 ||
      this.workOrderQnty === this.work_order_qty
    ) {
      this.doTruckOwnerForm.patchValue({
        remaining_tons: (this.total_quantity - this.workOrderQnty).toFixed(3),
      });
    } else {
      this.doTruckOwnerForm.patchValue({
        remaining_tons: this.total_quantity.toFixed(3),
      });
      this.snackBar.open(
        "Do Quantity Should not Exceed With Work Order Quantity",
        "Fail",
        {
          duration: 5000,
        }
      );
      return;
    }
    if (truckObj.price_per_ton === 0) {
      this.snackBar.open("Price per ton cannot be zero", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (truckObj.do_quantity === 0) {
      this.snackBar.open("Do Quantity  cannot be zero", "Fail", {
        duration: 5000,
      });
      return;
    }
    this.services.addDoTruckowner(truckObj, this.token).subscribe(
      (response: any) => {
        this.matdialogref.close({ event: "Success" });
        if (response.status === 201) {
          this.snackBar.open(
            "DO to truckowner created successfully",
            "Success",
            {
              duration: 5000,
            }
          );
        }
        setTimeout(() => {
          this.loading = false; // ✅ Enable button after response
          (event.target as HTMLButtonElement).disabled = false; // ✅ Re-enable button
        }, 500);
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
}
